
define('eteration/ui/userpref-viewmodel',[
	'jquery',
	'knockout',
	'moment',
	'eteration/eteration-i18n',
	'eteration/eteration',
	'eteration/eteration-ajax',
	'ui-helper/cookie-helper',
	'eteration/ui/form-viewmodel',
	'ui-helper/currency-helper',
	'ui-helper/gtm-helper',
	'eteration/widgets/ui-i18n',
	'eteration/widgets/ui-selectpicker',
	'eteration/widgets/ui-money',
	'jstorage'

], function($, ko, moment, i18n, Eteration, etrAjax, cookieHelper, FormViewModel, currencyHelper,gtmHelper) {

	function UserPreferencesModel(data) {
		var self = this;
		self.selectCountry = ko.observable(data && data.selectCountry);
		self.selectLanguage = ko.observable(data && data.selectLanguage);
		self.selectCurrency = ko.observable(data && data.selectCurrency);

		return self;
	}

	function UserPreferencesVM() {

		var cleanUp = function() {
			var lc = $("meta[name='languagecountry']").attr('content');
			if (lc) {
				lc = lc.split("-");
				if(lc[0]&&lc[0]!==""){
					$.each(localStorage, function(key, value) {
						if (key != null && ( ( key.startsWith('__ports') && !key.startsWith('__ports' + '-' + lc[0]) ) || ( key.startsWith('__ui-portselect-ports') && !key.startsWith('__ui-portselect-ports' + '-' + lc[0]) ) ) ) {
							localStorage.removeItem(key);
						}
					});
				}
			}
		}
		cleanUp();

		var self = this;
		ko.utils.extend(self, new FormViewModel.FormViewModel());
		
		var languageCountry, country, language, currency = null;

		var userLang = i18n.getUserLocale();

		var countries = null;
		var currencies = null;

		var selectedCountryIndex = null, countryDefaultCurrency;
		var isNewHeader = false;
		if($('.main-header .quick-nav').length){
			isNewHeader = true;
		}
	
		self.rememberSelection = ko.observable(false);

		self.countryList = ko.observableArray();
		self.languageList = ko.observableArray([]);
		self.currencyList = ko.observableArray([]);
		self.activeCountry = ko.observable();
		self.activeLanguage = ko.observable();
		self.activeCurrency = ko.observable();
		
		self.currencyLogoPath = ko.observable('cfa-usd');
		self.currencies = currencyHelper.currencyList;
		
        self.imagePath = ko.observable();		
		self.getCountryFlag = function(countryCodeParam) {
            self.imagePath('icon-' + countryCodeParam.toUpperCase());
        }

		function convertToCdn(url) {
			var cdnUrl = url;
			if (url.indexOf("http://") != 0 && url.indexOf("https://") != 0) {
				cdnUrl = Eteration.toCDNPATH(url);
			}
			return cdnUrl;
		}

		function getSelectedCountryIndex(countryList) {
			for (var i=0; i<countryList.length; i++){
				if(countryList[i].code==self.userPreferences().selectCountry()){
					return i;
				}
			}
		}
		
		var countrySelector = {
			app : 'app.common',
			service : '/parameters/countries/'+userLang + "/" + i18n.getUserCountry(),
			cache : true,
			cdn : true,
			disableLoader : true,
			callback : function(response) {
				countries = response.data;
				if(countries) {
					selectedCountryIndex = getSelectedCountryIndex(response.data.list);
					countryDefaultCurrency = countries.defaultCountry ? countries.defaultCountry.defaultCurrency : null;
					cookieHelper.setCookie("CarrentDefaultCurrency",response.data.defaultCountry.defaultCurrency);
					self.setCountryList();
					if(!isNewHeader && !currencies) {
						etrAjax.get(currencySelector);
					}
				}
				$('#preferencesFormContent').show();
			}
		}
		
		var setSelectCurrency = function() {
			if (JSON.stringify(currencies).indexOf(data.selectCurrency) > -1)
				self.userPreferences().selectCurrency(data.selectCurrency);
			else if (JSON.stringify(currencies).indexOf(countryDefaultCurrency) > -1)
				self.userPreferences().selectCurrency(countryDefaultCurrency);
		}
		
		self.setCountryList = function() {
			if (data) {
				self.countryList(countries.list);
				self.languageList(self.countryList()[selectedCountryIndex].languages)

				self.userPreferences().selectCountry(data.selectCountry);
				self.userPreferences().selectLanguage(data.selectLanguage);
				setSelectCurrency();
				self.activeLanguage(data.selectLanguage.toLocaleUpperCase().replace(/İ/g,'I'));
				self.activeCountry(data.selectCountry.toLocaleUpperCase().replace(/İ/g,'I'));
				self.imagePath('icon-' + data.selectCountry.toUpperCase());
				
				var selectedLanguage = $('#languageSelector').val();
				self.makeLanguageSelectionJobs(selectedLanguage);
				
				self.refreshSelectPicker();
			}
		};
		self.closeUserPreferenceLink = function() {
			$('#userPreferenceLink').click();
		}
		self.closeUserCurrencyLink = function() {
			$('#userCurrencyLink').click();
		}
		self.refreshSelectPicker = function() {
			$(".dropdownselect").selectpicker("refresh");
		}

		self.removeTitleSelectPicker = function (){
			setTimeout(function(){
				$('button.selectpicker').attr('title','');
			},500);
		}

		$('#headerRightPaneForm').click(function(){
			self.removeTitleSelectPicker();
		});

		self.countryOptionRender = function(option, item) {
			
			if(!isNewHeader){
				$(option).attr('data-content', '<div class="flags flags-cstm icon-' + item.code.toUpperCase() + '" alt="' + item.name + '" /><span></span>' + item.name);		
			}
			self.removeTitleSelectPicker();


		}
		

		self.countrySelectionChanged = function(data, event) {
			var selectedCountry = $(event.target).val();
			selectedCountryIndex=getSelectedCountryIndex(self.countryList());
			
			if (selectedCountry) {
				self.languageList(self.countryList()[selectedCountryIndex].languages);
				self.userPreferences().selectCountry(selectedCountry);
				self.userPreferences().selectLanguage(self.countryList()[selectedCountryIndex].defaultLanguage);
				self.imagePath('icon-' + selectedCountry.toUpperCase());
			}
			self.refreshSelectPicker();
			self.removeTitleSelectPicker();
		};

		self.languageOptionRender = function(option, item) {
			if(!isNewHeader){
				$(option).attr('data-content', '<div class="flags flags-cstm2"><div class="margin-center common-icon" title="' + item.name + '" /></div><span></span>' + item.name);
			}
			self.removeTitleSelectPicker();
		};

		self.languageSelectionChanged = function(data, event) {
			var selectedLanguage = $(event.target).val();
			self.userPreferences().selectLanguage(selectedLanguage);
			if(isNewHeader){ // new header
				self.changePreferences();
			}
			self.removeTitleSelectPicker();
		};

		self.makeLanguageSelectionJobs = function(selectedLanguage) {
			if (self.userPreferences().selectCountry() ) {
				self.languageList(self.countryList()[selectedCountryIndex].languages);
				self.userPreferences().selectLanguage(selectedLanguage);
				self.imagePath('icon-' + self.userPreferences().selectCountry().toUpperCase());
			}
		};

		
		var getCurrencyList = {
			app : 'app.common',
			service : '/parameters/currenciesnew/'+userLang,
			disableLoader : true,
			cache : true,
			cdn : true,
			callback : function(response) {
				currencies = response.data;
				self.currencyList(currencies);
				self.refreshSelectPicker();
				if(currencies && JSON.stringify(currencies).indexOf(currency) > -1) {
					self.currencyLogoPath('cfa-' + currency);
					self.activeCurrency(currency);
				}
				$('#currencyFormContent').show();
			}
		}
		
		var currencySelector = { //after sdl header update will remove
			app : 'app.common',
			service : '/parameters/currenciesnew/'+userLang,
			disableLoader : true,
			cache : true,
			cdn : true,
			callback : function(response) {
				currencies = response.data;
				if (currencies && countries && data) {
					$('#currencySelector option[value=""]').remove();
					self.currencyList(currencies);
					setSelectCurrency();
					self.refreshSelectPicker();
				}
				$('#currencyFormContent').show();
				if(!isNewHeader)
					$('#preferencesFormContent').show();
			}
		}
		


		self.currencyOptionRender = function(option, item) {
			var currency_control = true;
			for (var i = 0; i < self.currencies.length; i++) {

				if (self.currencies[i].code === item.code) {
					if (self.currencies[i].icon != "") {
						$(option).attr('data-content', '<i class="fa ' + self.currencies[i].icon + ' gray"></i><span></span>' + item.name);
						if($('.main-header .quick-nav').length){
							$(option).html('<i class="fa ' + self.currencies[i].icon + ' gray"></i>');
						}
					} else {
						$(option).attr('data-content', '<i class="fa gray fs-22">' + self.currencies[i].sign + '</i><span></span>' + item.name);
						if($('.main-header .quick-nav').length){
							$(option).html('<i class="fa gray fs-22">' + self.currencies[i].sign + '</i>');
						}
					}
					currency_control = false;
					break;
				}
			}
			if (currency_control) {
				$(option).attr('data-content', '<i class="fa fa-' + item.code + ' gray"></i><span></span>' + item.name);
			}
		}

		function checkDefaultCurrencyExistInList(dc) {
			var retVal = false;
			if (self != null && self.currencyList() != null) {
				if (self.currencyList().length > 0 && dc != null) {
					for (var i = 0; i < self.currencyList().length; i++) {
						if (self.currencyList()[i].code.toUpperCase() == dc.toUpperCase()) {
							retVal = true;
						}
					}
				}
			}
			return retVal;
		}

		var acceptedLanguages = [ "tr", "en", "ru", "fr", "de", "zh", "it", "es", "pt", "ko", "ja", "uk", "th", "ar" ];

		function prepareCurrencyDataForGtm (oldCurrency,newCurrency ){
			var datagtm = {
				oldCurrency : oldCurrency,
				newCurrency : newCurrency
			}
			gtmHelper.pushCurrencyData(datagtm);
		}


		self.changeCurrency = function(paramLanguageCode) {

			var oldCurrency = cookieHelper.getCookie("Currency");
			var newCurrency = self.userPreferences().selectCurrency();
			self.allowPageChangeWithoutClearTerminal();
			
			if (self.rememberSelection()) {
				if (self.userPreferences().selectCurrency() != null && self.userPreferences().selectCurrency() != "") {
					cookieHelper.setCookie("Currency", self.userPreferences().selectCurrency(), 365, "/", true);
				} else {
					if (cookieHelper.getCookie("Currency") != null) {
						cookieHelper.setCookie("Currency", null, 0, "/", true);
					}
				}
			} else {
				cookieHelper.setCookie("Currency",self.userPreferences().selectCurrency(), 0, "/", true);
			}
			prepareCurrencyDataForGtm (oldCurrency,newCurrency );
			window.location.reload();
		}
		
		self.changePreferences = function(paramLanguageCode, paramCountryCode, loginScreen) {
			self.allowPageChangeWithoutClearTerminal();
			var countryCode, languageCode;
			if (loginScreen) {

				if (cookieHelper.getCookie("Locale") != "" || cookieHelper.getCookie("LocaleOld") != "") {
					if (cookieHelper.getCookie("Locale") != "") {
						languageCountry = cookieHelper.getCookie("Locale");
					} else {
						languageCountry = cookieHelper.getCookie("LocaleOld");
						if (languageCountry != "")
							cookieHelper.setCookie("Locale", languageCountry, 0, "/", true);
					}
				} else {
					if (paramLanguageCode != "") {
						languageCode = paramLanguageCode;
					} else {
						languageCode = self.userPreferences().selectLanguage();
					}
					if (paramCountryCode != "") {
						countryCode = paramCountryCode;
					} else {
						countryCode = self.userPreferences().selectCountry();
					}
					languageCountry = languageCode + "-" + countryCode;
					cookieHelper.setCookie("Locale", languageCountry, 365, "/", true);
				}

			} else {
				languageCode = self.userPreferences().selectLanguage();
				countryCode = self.userPreferences().selectCountry();

				if (!self.languageList() || self.languageList().length < 1) {
					// int redirection
					etrAjax.get({
						app : 'app.common',
						service : '/parameters/browserlanguage',
						disableLoader : true,
						disableErrorHandling : true,
						async : false,
						callback : function(response) {
							countryCode = "int";
							if (response && response.data && _.contains(acceptedLanguages, response.data)) {
								languageCode = response.data;
							}
						}
					});

				}

				languageCountry = languageCode + "-" + countryCode;
				var currentLocale = cookieHelper.getCookie("Locale");
				var oldLocale = cookieHelper.getCookie("LocaleOld");
				if (oldLocale != "")
					cookieHelper.setCookie("LocaleOld", oldLocale, 365, "/", true);
				else {
					if (currentLocale != "")
						cookieHelper.setCookie("LocaleOld", currentLocale, 365, "/", true);
				}
				cookieHelper.setCookie("Locale", languageCountry, 0, "/", true);

			}
			
			self.getCountryFlag(self.userPreferences().selectCountry());
			
			if (self.rememberSelection()) {
				cookieHelper.setCookie("Locale", languageCountry, 365, "/", true);
				cookieHelper.setCookie("LocaleOld", languageCountry, 365, "/", true);
			}

			var lc = $("meta[name='languagecountry']").attr('content').split("-");
			var ol = cookieHelper.getCookie("userPrefLang");
			var code;
			if (lc != null)
				code = lc[0];
			if ((code != null && code != self.userPreferences().selectLanguage()) || (ol != null && ol != self.userPreferences().selectLanguage())) {
				$.each(localStorage, function(key, value) {
					if (key != null && (key.startsWith("__ports") || key.startsWith('__ui-portselect-ports')) ) {
						localStorage.removeItem(key);
					}
				});
			}

			// change language
			var pageId = i18n.getMetaDataAttribute("PageID");
			etrAjax.post({
				app : 'app.cms',
				disableLoader : true,
				disableErrorHandling : true,
				service : '/content/pageurl/' + 'thy' + '/' + pageId + '/' + languageCountry,
				callback : function(response) {

					var href = window.location.origin;// root;
					var intLang;
					var windowSearchParam = window.location.search;
					var urlHashParam = window.location.hash;

					if (response.data) {
						href += response.data;
						if(href != window.location.href)
							window.location.href = href + windowSearchParam + urlHashParam;
					} else {
                        try {
                        	intLang = languageCountry.split("-")[0];
                        } catch (e) {
                            intLang ="en";
                        }
                        href+= "/" + intLang+"-int";
                        window.location.href = href + windowSearchParam + urlHashParam;
					}
				}
			});

			cookieHelper.setCookie("userPrefLang", self.userPreferences().selectLanguage(), 365, "/", true);
		}

		try {
			language = i18n.getUserLocale();
			country = i18n.getUserCountry();
		} catch (e) {
			language = "en";
			country = "us";
		}
		
		try {
			if (cookieHelper.getCookie("cidCheck") == "") {

				cookieHelper.setCookie("cidCheck", "true", 0, "/", true);
				var terminatedByCountLimitConversationIds = $.jStorage.get("app/terminatedByCountLimitConversationIds");
				if (terminatedByCountLimitConversationIds != null) {

					etrAjax.post({
						app : 'app.ibs',
						service : '/booking/clearAllConversations/' + terminatedByCountLimitConversationIds,
						disableLoader : true,
						global : false
					});
				}

			}
		} catch (e) { }
		

		if (cookieHelper.getCookie("Currency") != "") {
          /*
			cookieHelper.setCookie("Currency","TRY", 0, "/", true);
			currency = cookieHelper.getCookie("Currency");
			if(isNewHeader && !currencies) {
				etrAjax.get(getCurrencyList);
			}
		}else{
        */
			currency = cookieHelper.getCookie("Currency");
			if(isNewHeader && !currencies) {
				etrAjax.get(getCurrencyList);
			}
		}

		var data = {
			"selectCountry" : country.toLowerCase(),
			"selectLanguage" : language.toLowerCase(),
			"selectCurrency" : currency
		};

		self.userPreferences = ko.observable(new UserPreferencesModel(data));
		
		if (country != null) {
            self.getCountryFlag(country);
        }
		
		//setting values after getting value from cookie
		if(!countries) {
			etrAjax.get(countrySelector);
		}
		
		// Higlight Selected Buttons on Header
		try {
			var getURLofthePage = i18n.getMetaDataAttribute("currentPageURL");
			var headerLinks = $("header .navbar-left li a");

			for (var headerIndex = 0; headerIndex < headerLinks.length; headerIndex++) {

				var headerLink = headerLinks[headerIndex];

				if (headerLink.pathname == getURLofthePage) {
					$(headerLink).addClass("active");
				}
			}

			var msLink = $("header .navbar-right li a")[0];

			if (msLink.pathname == getURLofthePage) {
				$(msLink).addClass("active");
			}

		} catch (e) {

		}

		$("#userPreferenceLink").bind("click", function() {
			$('.show-right-partial-mbl').removeClass('in');
			if ($('#preferencesForm').is(':hidden')) {
				if (!countries) {
					etrAjax.get(countrySelector);
				} else {
					setSelectCurrency();
				}
				self.refreshSelectPicker();
			}
		});

		$("#userCurrencyLink, #currencyCard").bind("click", function() {
			if ($('#currencyForm, .currency-card').is(':hidden')) {
				if (!currencies) {
					etrAjax.get(currencySelector);
				} else if(countries) {
					setSelectCurrency();
				}
				self.refreshSelectPicker();
			}
		});

		self.isHomepageFeedbackIconActive = ko.observable();

		etrAjax.get({
			app: 'app.ibs',
			service: '/booking/headerparameters',
			disableErrorHandling: true,
			disableLoader: true,
			global: false,
			callback: function (response) {
				if (response && response.data) {
					self.isHomepageFeedbackIconActive(response.data.isHomepageFeedbackIconActive);
				}
			}
		});
	}

	return {
		UserPreferencesVM : UserPreferencesVM
	};
});

